import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppSettings } from '../enums/app-settings.enum';
import { EnvironmentConfigurations } from '../models/EnvironmentConfigurations';

@Injectable({
providedIn: 'root'
})
export class ApplicationInitializationService {

    environmentConfig: EnvironmentConfigurations;
    
    constructor(private http: HttpClient) { }

    initializeApp() {
        return this.http.get(environment?.B2C_URL + '/eInitiativeEnvironmentConfigurations.service').toPromise()
            .then(async (response: any) => {
                this.environmentConfig = new EnvironmentConfigurations();
                this.environmentConfig.PLANT_A_TREE_SUBSCRIBE_ADDONS = response.PLANT_A_TREE_SUBSCRIBE_ADDONS;
                this.environmentConfig.EINITIATIVE_SOCIAL_MEDIA_POST_CONTENT = response.EINITIATIVE_SOCIAL_MEDIA_POST_CONTENT;
                this.environmentConfig.EINITIATIVE_INTERVAL = response.EINITIATIVE_INTERVAL;
                this.environmentConfig.EINITIATIVE_PLANT_A_TREE_EVENT_ENABLE = response.EINITIATIVE_PLANT_A_TREE_EVENT_ENABLE;
                this.environmentConfig.REDIRECTION_URL_PAGE_NOT_FOUND = response.REDIRECTION_URL_PAGE_NOT_FOUND;
                this.environmentConfig.EINITIATIVE_PLANT_A_TREE_EVENT_SHARE_OPTION_ENABLE = response.EINITIATIVE_PLANT_A_TREE_EVENT_SHARE_OPTION_ENABLE;
            })
            .catch((error) => {
                // When service fails, get the configurations from the backup
                this.prepareConfigurationBackup();

            });
    }

    prepareConfigurationBackup() {
        this.environmentConfig = new EnvironmentConfigurations();
        this.environmentConfig.PLANT_A_TREE_SUBSCRIBE_ADDONS = [{"accountType":"POSTPAID","skuId":"sku960321"},{"accountType":"PREPAID","skuId":"esku3210337"}];
        this.environmentConfig.EINITIATIVE_SOCIAL_MEDIA_POST_CONTENT = {"card":"summary","title":"Title of Your Post","description":"Description of Your Post","image":"URL_OF_YOUR_IMAGE","url":"URL_OF_YOUR_PAGE"};
        this.environmentConfig.EINITIATIVE_INTERVAL = 30;
        this.environmentConfig.EINITIATIVE_PLANT_A_TREE_EVENT_ENABLE = true;
        this.environmentConfig.REDIRECTION_URL_PAGE_NOT_FOUND = "https://onlineservices.etisalat.ae/scp/global/pageNotFound.jsp";
        this.environmentConfig.EINITIATIVE_PLANT_A_TREE_EVENT_SHARE_OPTION_ENABLE = 'TRUE';
    }
    
}
